const getQuouteProduct = (products) => {
  return products.map((product) => ({
    product_id: product.id,
    name: product.title,
    vendor: product.vendor,
    variant_id: product.variant_id,
    image: product.image,
    product_url: `${Shopify.shop}${product.url}`,
    qty: product.quantity,
    price: product.price,
    options: product.variant_title,
    sku: product.sku,
    quoteKey: getQuoteKey(product),
    quoteId: 1,
    group_id: 0
  }))
}

const getQuoteKey = (product) => {
  const encodeProductName = encodeURIComponent(product.title)

  return `${Shopify.shop}/groupId=0/pId=${product.id}/vId=${product.variantId}/name=${encodeProductName}/vendor=${product.vendor}/sku=${product.sku}/option=${product.variant_title}`
}

export { getQuouteProduct }
